import React, { useEffect } from "react";
import {
  Form,
  Grid,
  Segment,
  Button,
  TextArea,
  Dropdown,
} from "semantic-ui-react";
import {
  addClinicaOrion,
  addDocumentoClinica,
  editClinicaOrion,
  getClinica,
  getDocumentosClinica,
  getTiposDoc,
  deleteDocumentoClinica,
} from "../../../../api/Orion/clinica";
import * as Yup from "yup";
import { useAuth, useAnalisisFactura } from "../../../../hooks";
import { BASE_API, TIMEOUTS } from "../../../../utils/constantes";
import { toast } from "react-toastify";
import { useFormik, Field } from "formik";
import Reducer from "./Reducer_clinica";
import { Link } from "react-router-dom";
import { getProvincias } from "../../../../api/Common/provincia";
import { getLocalidades } from "../../../../api/Common/localidad";
import { fetchUploadFile } from "../../../../api/Common/file";
import { LocationSelector, DocumentManager, RenovacionSection, FacturaAnalisisModal } from "../../../../components/Common";
import "./AbmAdmin.scss";

export function ClinicaOrionCreateEditShow(props) {
  const initialState = {
    provincias: [],
    localidades: [],
  };

  const [state, dispatch] = React.useReducer(Reducer, initialState);
  const { provincias, localidades } = state;

  const { auth } = useAuth();
  const { history } = props;
  const { id, type_action } = props.match.params;
  const disabledGeneral = type_action === "show" ? true : false;
  const isAddMode = !id;
  const [clinica, setClinica] = React.useState([]);
  const [tipoDocumento, setTipoDocumento] = React.useState("");
  const [tiposDocs, setTiposDocs] = React.useState([]);
  const [documentos, setDocumentos] = React.useState([]);
  const [deletdDocs, setDeletedDocs] = React.useState([]);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [isUploadingDoc, setIsUploadingDoc] = React.useState(false);
  const analisisFactura = useAnalisisFactura();

  // Solo los documentos de tipo Factura se analizan con IA
  const esTipoFactura = (idTipoDoc) => {
    const tipo = tiposDocs.find((t) => String(t.id) === String(idTipoDoc));
    if (!tipo) return false;
    return tipo.valor === "factura" || (tipo.nombre || "").toLowerCase() === "factura";
  };
  function formatearFecha(fecha) {
    const date = new Date(fecha);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // meses van de 0 a 11
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const formik = useFormik({
    initialValues: initialValues(clinica),
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (formValue) => {
      try {
        if (formValue.clinica_ultima_renovacion) {
          formValue.clinica_ultima_renovacion = formatearFecha(
            formValue.clinica_ultima_renovacion
          );
        }
        if (formValue.clinica_renovacion_fecha) {
          formValue.clinica_renovacion_fecha = formatearFecha(
            formValue.clinica_renovacion_fecha
          );
        }

        if (isAddMode) {
          const response = await addClinicaOrion(formValue);
          if (response.status === "error") {
            toast.error(`Error en el sistema: ${JSON.stringify(response)}`);
          } else {
            toast.success("Se guardó exitosamente la clínica.", {
              onClose: () => {
                history.push(`/admin/clinica_orion/listado`);
              },
              autoClose: TIMEOUTS.TOAST_AUTO_CLOSE,
            });
          }
        } else {
          const response = await editClinicaOrion(id, formValue);
          if (response.status === "error") {
            toast.error(`Error en el sistema: ${JSON.stringify(response)}`);
          } else {
            toast.success("Se guardó exitosamente la clínica.", {
              onClose: () => {
                history.push(`/admin/clinica_orion/listado`);
              },
              autoClose: TIMEOUTS.TOAST_AUTO_CLOSE,
            });
          }
        }
      } catch (error) {
        console.error("Error al guardar clínica:", error);
        toast.error(error.message || "Error al guardar la clínica");
      }
    },
    enableReinitialize: isAddMode ? false : false,
  });
  const fetchProvincias = async () => {
    try {
      const data = await getProvincias();
      if(data && data.results) {
        let provincias_process = data.results.map((x) => {
          return { key: x.id, text: x.nombre, value: x.id };
        });
        dispatch({ type: "SET_PROVINCIA", provincias: provincias_process });
      }
    } catch (error) {
      console.error("Error al obtener provincias:", error);
      toast.error("Error al cargar provincias");
    }
  };

  const fetchLocalidades = async (provincia) => {
    try {
      const data = await getLocalidades(`provincia=${provincia}`);
      if(data && data.results) {
        let localidades_process = data.results.map((x) => {
          return { key: x.id, text: x.nombre, value: x.id };
        });
        return localidades_process;
      }
      return [];
    } catch (error) {
      console.error("Error al obtener localidades:", error);
      return [];
    }
  };
  useEffect(() => {
    if (!isAddMode) {
      const fetchClinica = async () => {
        try {
          const data = await getClinica(`${props.match.params.id}`);
          if(data) {
            changeProvincia(data?.clinica_provincia.id);
            formik.setFieldValue("clinica_nombre", data.clinica_nombre);
            formik.setFieldValue(
              "clinica_provincia",
              data?.clinica_provincia.id
            );
            formik.setFieldValue(
              "clinica_localidad",
              data?.clinica_localidad.id
            );
            formik.setFieldValue("clinica_direccion", data.clinica_direccion);
            formik.setFieldValue("clinica_telefono", data.clinica_telefono);
            formik.setFieldValue(
              "clinica_codigo_postal",
              data.clinica_codigo_postal
            );
            formik.setFieldValue("clinica_comentario", data.clinica_comentario);
            formik.setFieldValue(
              "clinica_prestaciones",
              data.clinica_prestaciones
            );
            formik.setFieldValue("clinica_convenio", data.clinica_convenio);
            formik.setFieldValue("clinica_camara", data.clinica_camara);
            formik.setFieldValue("clinica_guardia", data.clinica_guardia);
            formik.setFieldValue("clinica_renovacion", data.clinica_renovacion);
            formik.setFieldValue(
              "clinica_renovacion_frecuencia",
              data.clinica_renovacion_frecuencia
            );
            formik.setFieldValue(
              "clinica_renovacion_fecha",
              data.clinica_renovacion_fecha
            );
            formik.setFieldValue(
              "clinica_ultima_renovacion",
              data.clinica_ultima_renovacion
                ? data.clinica_ultima_renovacion
                : new Date().toISOString().slice(0, 10)
            );

            setClinica(data);
          }
        } catch (error) {
          console.error("Error al obtener clínica:", error);
          toast.error("Error al cargar los datos de la clínica");
        }
      };

      const getClinicaDocs = async () => {
        try {
          const data = await getDocumentosClinica(id);
          if(data && data.results) {
            setDocumentos(data.results);
          }
        } catch (error) {
          console.error("Error al obtener documentos de clínica:", error);
        }
      };

      getClinicaDocs();
      fetchClinica();
    }

    const tiposDocs = async () => {
      try {
        const data = await getTiposDoc();
        if(data && data.results) {
          setTiposDocs(data.results);
        }
      } catch (error) {
        console.error("Error al obtener tipos de documento:", error);
      }
    };

    tiposDocs();
    fetchProvincias();
  }, []);

  const changeProvincia = async (value) => {
    try {
      formik.setFieldValue("clinica_provincia", value);
      let localidades_process = await fetchLocalidades(value);

      dispatch({ type: "SET_LOCALIDAD", localidades: localidades_process });
    } catch (error) {
      console.error("Error al cambiar provincia:", error);
      toast.error("Error al cargar localidades");
    }
  };
  const handleFileSelect = (file) => {
    setSelectedFile(file || null);
  };

  const handleUploadDocumento = async () => {
    try {
      if (!tipoDocumento) {
        toast.error("Error: Debe seleccionar un tipo de documento");
        return;
      }

      if (!id) {
        toast.error("Error: Debe guardar la clínica antes de agregar documentos");
        return;
      }

      if (!selectedFile) {
        toast.error("Error: Debe seleccionar un archivo");
        return;
      }

      setIsUploadingDoc(true);

      const formData = new FormData();
      formData.append("file", selectedFile);

      const { status, data } = await fetchUploadFile(formData);

      if (status !== "success" || !data || !data[0]) {
        toast.error("Error al subir el archivo");
        setIsUploadingDoc(false);
        return;
      }

      try {
        const result = await addDocumentoClinica(id, tipoDocumento, data[0]);

        if (result && result.status !== "error") {
          setDocumentos([...documentos, result]);
          toast.success("Documento cargado correctamente");
          setSelectedFile(null);

          if (esTipoFactura(tipoDocumento)) {
            analisisFactura.analizarArchivo({
              urlArchivo: data[0],
              tipoCarga: "orion_clinica_documento",
              documentoId: result.id,
            });
          }
        } else {
          toast.error("Error al agregar el documento");
        }
      } catch (error) {
        console.error("Error al agregar documento:", error);
        toast.error("Error al agregar el documento");
      }

    } catch (error) {
      console.error("Error al subir archivo:", error);
      toast.error("Error al subir el archivo");
    } finally {
      setIsUploadingDoc(false);
    }
  };

  const handleDocDelete = async (id) => {
    if (deletdDocs.includes(id)) {
      setDeletedDocs(deletdDocs.filter((doc) => doc !== id));
      let deletedDoc = documentos.find((doc) => doc.id === id);
      deletedDoc.deleted = false;

      setDocumentos([...documentos]);

      return;
    } else {
      setDeletedDocs([...deletdDocs, id]);
      let deletedDoc = documentos.find((doc) => doc.id === id);
      deletedDoc.deleted = true;
      setDocumentos([...documentos]);
    }
  };

  const handleSave = async () => {
    try {
      await Promise.all(deletdDocs.map(async (id) => {
        try {
          await deleteDocumentoClinica(id);
        } catch (error) {
          console.error(`Error al eliminar documento ${id}:`, error);
        }
      }));
    } catch (error) {
      console.error("Error al guardar cambios de documentos:", error);
      toast.error("Error al eliminar documentos");
    }
  };

  const handleTipoDocChange = (event, data) => {
    setTipoDocumento(data.value);
  };

  return (
    <>
    <Form className="form-compact" onSubmit={formik.handleSubmit} style={{ display: "grid" }}>
      <p><strong>Clínica</strong></p>
      <Grid as={Segment}>
        <Grid.Row className="segment_border_primary">
          <Grid.Column computer={5} mobile={16} tablet={16}>
            <h5>* Nombre</h5>
            <Form.Input
              disabled={disabledGeneral}
              name="clinica_nombre"
              fluid
              placeholder="Ingrese un nombre corto"
              value={formik.values.clinica_nombre}
              onChange={(_, data) => formik.setFieldValue("clinica_nombre", data.value)}
              error={formik.values.clinica_nombre !== "" ? false : true}
            />
          </Grid.Column>
          <Grid.Column computer={5} mobile={16} tablet={16}>
            <h5>Teléfono</h5>
            <Form.Input
              disabled={disabledGeneral}
              name="clinica_telefono"
              fluid
              placeholder="Ingrese un teléfono"
              value={formik.values.clinica_telefono}
              onChange={(_, data) => formik.setFieldValue("clinica_telefono", data.value)}
              error={formik.values.clinica_telefono !== "" ? false : true}
            />
          </Grid.Column>
          <LocationSelector
            provincias={provincias}
            localidades={localidades}
            provinciaValue={formik.values.clinica_provincia}
            localidadValue={formik.values.clinica_localidad}
            onProvinciaChange={changeProvincia}
            onLocalidadChange={(value) => formik.setFieldValue("clinica_localidad", value)}
            disabled={disabledGeneral}
            required={true}
          />
          <Grid.Column computer={3} mobile={16} tablet={16}>
            <h5>* Dirección</h5>
            <Form.Input
              disabled={disabledGeneral}
              name="clinica_direccion"
              fluid
              placeholder="Ingrese una dirección"
              value={formik.values.clinica_direccion}
              onChange={(_, data) => formik.setFieldValue("clinica_direccion", data.value)}
              error={formik.values.clinica_direccion !== "" ? false : true}
            />
          </Grid.Column>
          <Grid.Column computer={3} mobile={16} tablet={16}>
            <h5>CP</h5>
            <Form.Input
              disabled={disabledGeneral}
              name="clinica_codigo_postal"
              fluid
              placeholder="CP"
              value={formik.values.clinica_codigo_postal}
              onChange={(_, data) => formik.setFieldValue("clinica_codigo_postal", data.value)}
              error={formik.values.clinica_codigo_postal !== "" ? false : true}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column computer={4} mobile={16} tablet={16}>
            <h5>Prestaciones</h5>
            <TextArea
              disabled={disabledGeneral}
              name="clinica_prestaciones"
              placeholder="Pediatria, solo adultos, oftalmología, etc."
              value={formik.values.clinica_prestaciones}
              onChange={(_, data) => formik.setFieldValue("clinica_prestaciones", data.value)}
            />
          </Grid.Column>
          <Grid.Column computer={3} mobile={16} tablet={16}>
            <h5>Convenio</h5>
            <Form.Group inline>
              <Form.Radio disabled={disabledGeneral} label="Sí" name="clinica_convenio" checked={formik.values.clinica_convenio === true} value={true} onChange={() => formik.setFieldValue("clinica_convenio", true)} />
              <Form.Radio disabled={disabledGeneral} label="No" name="clinica_convenio" checked={formik.values.clinica_convenio === false} value={false} onChange={() => { formik.setFieldValue("clinica_convenio", false); formik.setFieldValue("clinica_camara", false); }} />
            </Form.Group>
          </Grid.Column>
          <Grid.Column computer={3} mobile={16} tablet={16}>
            <h5>Convenio por camara</h5>
            <Form.Group inline>
              <Form.Radio disabled={disabledGeneral || !formik.values.clinica_convenio} value={true} checked={formik.values.clinica_camara} label="Si" name="clinica_camara" onClick={() => formik.setFieldValue("clinica_camara", true)} />
              <Form.Radio disabled={disabledGeneral || !formik.values.clinica_convenio} value={false} checked={!formik.values.clinica_camara} label="No" name="clinica_camara" onClick={() => formik.setFieldValue("clinica_camara", false)} />
            </Form.Group>
          </Grid.Column>
          <Grid.Column computer={2} mobile={16} tablet={16}>
            <h5>Tipo atencion</h5>
            <Form.Group inline>
              <Form.Radio disabled={disabledGeneral} value={true} checked={formik.values.clinica_guardia} label="Guardia" name="clinica_guardia" onClick={() => formik.setFieldValue("clinica_guardia", true)} />
              <Form.Radio disabled={disabledGeneral} value={false} checked={!formik.values.clinica_guardia} label="Turno" name="clinica_guardia" onClick={() => formik.setFieldValue("clinica_guardia", false)} />
            </Form.Group>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <RenovacionSection formik={formik} disabled={disabledGeneral} />
        </Grid.Row>
        <Grid.Row>
          <Grid.Column computer={16} mobile={16} tablet={16}>
            <h5>Comentarios</h5>
            <TextArea
              disabled={disabledGeneral}
              name="clinica_comentario"
              value={formik.values.clinica_comentario}
              onChange={(_, data) => formik.setFieldValue("clinica_comentario", data.value)}
            />
          </Grid.Column>
        </Grid.Row>

        <DocumentManager
          documentos={documentos}
          tiposDocs={tiposDocs}
          tipoDocumento={tipoDocumento}
          disabled={disabledGeneral || !id}
          onTipoDocChange={handleTipoDocChange}
          onFileChange={handleFileSelect}
          onUploadClick={handleUploadDocumento}
          uploadDisabled={!selectedFile || !tipoDocumento || disabledGeneral || !id}
          uploadLoading={isUploadingDoc}
          onDocDelete={handleDocDelete}
          id={id}
        />
        <Grid.Row>
          <Grid.Column computer={2} mobile={16} tablet={16}>
            <Button fluid disabled={disabledGeneral ? disabledGeneral : formik.isSubmitting} type="submit" content={isAddMode ? "Guardar" : "Actualizar"} primary onClick={() => handleSave()} />
          </Grid.Column>
          <Grid.Column computer={2} mobile={16} tablet={16}>
            <Button fluid content="Volver" primary component={Link} href="/admin/clinica_orion/listado" />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
    <FacturaAnalisisModal {...analisisFactura.modalProps} />
    </>
  );
}
function validationSchema() {
  return {
    clinica_nombre: Yup.string().required(true),
    clinica_direccion: Yup.string().required(true),
    clinica_provincia: Yup.string().required(true),
    clinica_localidad: Yup.string().required(true),
    clinica_codigo_postal: Yup.string().required(true),
    clinica_telefono: Yup.string().required(true),
  };
}

function initialValues(clinica) {
  return {
    clinica_nombre: clinica?.clinica_nombre ?? "",
    clinica_direccion: clinica?.clinica_direccion ?? "",
    clinica_provincia: clinica?.clinica_provincia ?? "",
    clinica_localidad: clinica?.clinica_localidad ?? "",
    clinica_comentario: clinica?.clinica_comentario ?? "",
    clinica_codigo_postal: clinica?.clinica_codigo_postal ?? "",
    clinica_telefono: clinica?.clinica_telefono ?? "",
    clinica_prestaciones: clinica?.clinica_prestaciones ?? "",
    clinica_convenio: clinica?.clinica_convenio,
    clinica_camara: clinica?.clinica_camara,
    clinica_guardia: clinica?.clinica_guardia,
    clinica_renovacion: clinica?.clinica_renovacion,
    clinica_renovacion_frecuencia: clinica?.clinica_renovacion_frecuencia ?? "",
    clinica_renovacion_fecha: clinica?.clinica_renovacion_fecha ?? "",
    clinica_ultima_renovacion:
      clinica?.clinica_ultima_renovacion ??
      new Date().toISOString().slice(0, 10),
  };
}
